import React from 'react';
import { connect } from 'react-redux';
import InputForm from '../components/InputForm';
import { fetchConfirm, clearForm } from '../actions';

const mapStateToProps = state => (
  {
    inputDisplay: state.input_page,
    form: state.form,
    errors: state.validationErrors,
    isError: state.validateError,
    requesting: state.isRequesting,
    form_settings: state.form_settings
  }
);

const mapDispatchToProps = dispatch => ({
  handleSubmit: (e) => {
    e.preventDefault();
    dispatch(fetchConfirm(e.target));
  },
  clearForm: () => {
    dispatch(clearForm());
  }
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InputForm);
